// extracted by mini-css-extract-plugin
var _1 = "AddressVerificationModal_address__0YUB3";
var _2 = "AddressVerificationModal_button__EwsN3";
var _3 = "AddressVerificationModal_closeButton__opS2y";
var _4 = "AddressVerificationModal_container__Bol1v";
var _5 = "AddressVerificationModal_content__s9AKT";
var _6 = "AddressVerificationModal_highlighted__LCKAK";
var _7 = "AddressVerificationModal_link__9x6Bo";
var _8 = "AddressVerificationModal_modal__1P-dp";
var _9 = "AddressVerificationModal_options__HgTyj";
var _a = "AddressVerificationModal_subtitle__lAMFJ";
var _b = "AddressVerificationModal_suggestion__rOLHz";
var _c = "AddressVerificationModal_title__OG5TE";
var _d = "AddressVerificationModal_wrapper__fYE8X";
export { _1 as "address", _2 as "button", _3 as "closeButton", _4 as "container", _5 as "content", _6 as "highlighted", _7 as "link", _8 as "modal", _9 as "options", _a as "subtitle", _b as "suggestion", _c as "title", _d as "wrapper" }
